<template>
  <div
    class="searchbar"
  >
    <div class="search-row">
      <input
        v-model="query"
        autocomplete="off"
        type="text"
        placeholder="Search"
        aria-label="Search"
        @keyup.enter="searchInput"
      >
    </div>
  </div>
</template>

<script>
import { setChecklistData, TOPIC_SEARCH_KEY } from '@/utils/checklist';

export default {
  emits: ['close'],
  data() {
    return {
      query: '',
    };
  },
  methods: {
    search(query) {
      setChecklistData(this.$store, TOPIC_SEARCH_KEY, this.$notify);
      this.$router.push({ name: 'search#index', query: { q: query }});
    },
    searchInput() {
      if (this.query) {
        this.$store.commit('search/recordSearch', this.query);
        this.search(this.query);
        this.$emit('close');
      }
    },
  },
};

</script>

<style lang='scss' scoped>
.searchbar {
  background: white;
  border: 1px solid var(--Colors-Border-border-primary, rgba(213, 215, 218, 1));
  box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05);
  border-radius: var(--radius-md);

  .search-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: rem-calc(250);
  }

  input {
    box-sizing: border-box;
    color: #666666;
    font-weight: $semi-bold;
    height: rem-calc(38);
    margin: rem-calc(1) 0 rem-calc(1) rem-calc(10);
    padding: rem-calc(6);
    background: transparent;

    &::-ms-clear {
      display: none;
    }
  }
}
</style>
